module.exports = __webpack_public_path__ + "6d36584f4205543deea500c8cd5bfde2.svg";